export default 'holdingAttribute';
